import { render, staticRenderFns } from "./AreaEmbargadaAutoInfracaoSp.vue?vue&type=template&id=0b1ca424&lang=pug"
import script from "./AreaEmbargadaAutoInfracaoSp.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaAutoInfracaoSp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports